import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "text-1" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M2.3335 3.66536V2.33203H8.00016M13.6668 3.66536V2.33203H8.00016M8.00016 2.33203V13.6654M8.00016 13.6654H6.3335M8.00016 13.6654H9.66683",
        stroke: "#7F7F83",
        "stroke-linecap": "square"
      })
    ], -1)
  ])))
}
export default { render: render }